import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { SurveyDto } from "src/common/types/survey";

export default function surveyConfigurationReducer(
  state: SurveyDto = initialState.surveyDto,
  action: AnyAction
): SurveyDto {
  switch (action.type) {
    case internalActionKeys.GET_SURVEY_SUCCESS:
    case internalActionKeys.PATCH_SURVEY_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
